import type { PortableTextBlock } from '@sanity/types';

interface TitleContent {
  _type: 'title';
  _key: string;
  title: Array<PortableTextBlock>;
}

interface SubtitleContent {
  _type: 'subtitle';
  _key: string;
  subtitle: Array<PortableTextBlock>;
}

export type ContentItem = TitleContent | SubtitleContent;

export function isItemTitle(item: ContentItem): item is TitleContent {
  return item._type === 'title';
}

export function isItemSubtitle(item: ContentItem): item is SubtitleContent {
  return item._type === 'subtitle';
}

export function getItemKey(item: ContentItem): string {
  return item._key;
}

export function getItemTitle(item: TitleContent) {
  return item.title;
}

export function getItemSubtitle(item: SubtitleContent) {
  return item.subtitle;
}
